import { BrowserRouter } from 'react-router-dom';
import Dashboard from './Dashboard';
import { HashProvider } from '../../Hooks/UseHash';
import useMobileVh from '../../Hooks/UseMobileVh';
import styled from 'styled-components';
import MenuList from './Menus/MenuList';
import CreateMenu from './Menus/CreateMenu';
import EditMenu from './Menus/EditMenu';
import BookingList from './Bookings/BookingList';
import SubRouter from './SubRouter';
import DepositAccountList from './DepositAccounts/DepositAccountList';
import RegisterDepositAccount from './DepositAccounts/RegisterDepositAccount';
import EditDepositAccount from './DepositAccounts/EditDepositAccount';
import { BreadCrumbs } from './BreadCrumbs';
import GlobalStyle from '../../GlobalStyle';
import { Toaster } from 'react-hot-toast';

interface EftposProps {
	hash: string;
}

export interface RouteDefinition {
	name: string;
	route: string;
	icon: string;
	component: (props: { routes?: RouteDefinition[] }) => JSX.Element;
	routes?: RouteDefinition[];
	exact?: boolean;
	excludeFromDropdown?: boolean;
}

const routes: RouteDefinition[] = [
	{
		name: 'Eftpos',
		route: '/',
		icon: 'fas fa-university',
		component: Dashboard,
		exact: true,
	},
	{
		name: 'Menus',
		route: '/menus',
		icon: 'fas fa-university',
		component: SubRouter,
		routes: [
			{
				name: 'List',
				route: '/',
				icon: 'fas fa-university',
				component: MenuList,
				exact: true,
			},
			{
				name: 'Create new menu',
				route: '/create',
				icon: 'fas fa-university',
				component: CreateMenu,
			},
			{
				name: 'Edit menu',
				route: '/edit/:id',
				excludeFromDropdown: true,
				icon: 'fas fa-university',
				component: EditMenu,
			},
		],
	},
	{
		name: 'Bookings',
		route: '/bookings',
		icon: 'fas fa-university',
		component: SubRouter,
		routes: [
			{
				name: 'List',
				route: '/',
				icon: 'fas fa-university',
				component: BookingList,
				exact: true,
			},
		],
	},
	{
		name: 'Deposit accounts',
		route: '/deposit-accounts',
		icon: 'fas fa-university',
		component: SubRouter,
		routes: [
			{
				name: 'List',
				route: '/',
				icon: 'fas fa-university',
				component: DepositAccountList,
				exact: true,
			},
			{
				name: 'Register deposit account',
				route: '/register',
				icon: 'fas fa-university',
				component: RegisterDepositAccount,
			},
			{
				name: 'Edit deposit account',
				route: '/edit/:id',
				excludeFromDropdown: true,
				icon: 'fas fa-university',
				component: EditDepositAccount,
			},
		],
	},
];

export default function Eftpos(props: EftposProps) {
	const { hash } = props;

	useMobileVh();

	return (
		<HashProvider hash={hash}>
			<BrowserRouter basename={`/u/eftpos/${hash}`}>
				<GlobalStyle />
				<Container className="container">
					<div className="row">
						<MainContainer className="col-xs-12">
							<BreadCrumbs rootName="Eftpos" routes={routes} />
							<SubRouter routes={routes} />
						</MainContainer>
					</div>
				</Container>
				<Toaster position="bottom-right" />
			</BrowserRouter>
		</HashProvider>
	);
}

const Container = styled.div`
	display: flex;
	flex-direction: column;
`;

const MainContainer = styled.div`
	min-height: calc(var(--vh, 1vh) * 100 - 45px);
	display: flex;
	flex-direction: column;
	position: relative;

	gap: 1rem;

	padding-bottom: 2rem;
`;
